/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Tooltip, IconButton, Button, TextField, Typography, FormControl, Collapse, Checkbox,FormLabel, Tabs, Tab, FormControlLabel, FormHelperText, Switch, InputAdornment } from '@material-ui/core'
import { ExpandLess, ExpandMore, Edit, Delete, Add, Clear } from '@material-ui/icons'

import { v4 as uuidv4 } from 'uuid';

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);
  
const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

class Link extends Component {
    state = {
        name : null,
        route : null,
        url : null,
        unsafe_http : false,
        show_settings : false,
        setting_tab_index : 0,
        query_params : [],
        is_standalone : false,
        show_in_sidebar : false
    }

    componentWillMount () {
        this.generateStateFromConfig()
    }

    componentDidUpdate (prevProps) {
        if (JSON.stringify(prevProps.config) !== JSON.stringify(this.props.config)) {
            this.generateStateFromConfig()
        }
    }

    generateStateFromConfig = () => {
        this.setState({
            ...this.state,
            name : this.props.config.name,
            route : this.props.config.route,
            url : this.props.config.default_params !== null ? this.props.config.default_params.url : null,
            query_params : this.props.config.default_params !== null ? this.props.config.default_params.query_params : [],
            is_standalone : this.props.config.default_params !== null ? this.props.config.default_params.is_standalone : false,
            unsafe_http : this.props.config.default_params !== null ? this.props.config.default_params.unsafe_http : false,
            show_settings : this.props.editing_id === this.props.config.id ? true : false,
            show_in_sidebar : this.props.config.show_in_sidebar
        }, () => console.log("Link State generated: ", this.state))
    }

    generatePath = (name) => {
        if (name !== null) {
            let path = name.toLowerCase()
            path = path.replace(/ /g,"_")
            path = '/' + path
            return path
        } else {
            return '/_'
        }
    }

    generateConfigFromState = () => {
        let config = this.props.config
        config.name = this.state.name
        config.route = this.generatePath(this.state.name)
        config.show_in_sidebar = this.state.show_in_sidebar
        config.default_params.url = this.state.url
        config.default_params.query_params = this.state.query_params
        config.default_params.is_standalone = this.state.is_standalone
        console.log("Generating Case Config : ", config)

        return config
    }

    isValid = () => {
        if (this.state.name !== null && this.state.url !== null) {
            return true
        } else {
            return false
        }
    }

    renderActions = (edit) => {
        if (!edit) {
            return (
                <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'space-around'}}>
                    <Tooltip title = 'Delete'>
                        <IconButton color = 'secondary' onClick = {() => this.props.delete(this.props.config)}>
                            <Delete fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title = 'Edit' >
                        <IconButton onClick = {() => {
                            this.setState({...this.state, show_settings : true}, () => {
                                this.props.enable_edit(this.props.config)
                            })
                        }}>
                            <Edit fontSize = 'small'/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    }

    renderSubmit = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '100%', display : 'flex', flexDirection : 'row-reverse', padding : '5px', borderTop: '1px solid rgba(0,0,0,0.12)'}}>
                    <Button
                        disabled = {!this.isValid()}
                        variant = "contained"
                        color = 'primary'
                        size = 'small'
                        onClick = {() => {
                            this.setState({...this.state, show_settings : false}, () => {
                                this.props.update(this.generateConfigFromState())
                            })
                        }}
                    >Submit</Button>
                    <Button
                        style = {{marginRight : '5px'}}
                        variant = "contained"
                        color = 'secondary'
                        size = 'small'
                        onClick = {() => {
                            if (this.state.name === null) {
                                this.setState({...this.state, show_settings : false}, () => {
                                    this.props.delete(this.props.config)
                                })
                            } else {
                                this.setState({...this.state, show_settings : false}, () => {
                                    this.generateStateFromConfig()
                                    this.props.update(this.props.config)
                                })
                            }
                        }}
                    >Cancel</Button>
                </div>
            )
        }
    }

    updateState = (state_key, value) => {
        this.setState({ ...this.state, [state_key] : value })
    }

    renderName = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <TextField
                        style = {{width : '100%'}}
                        label = "Name"
                        value = {this.state.name}
                        onChange = {(event) => {
                            if (event.target.value !== "") {
                                this.updateState('name', event.target.value)
                            } else {
                                this.updateState('name', null)
                            }
                        }}
                        variant = 'filled'
                        size = 'small'
                    />
                </div>
            )
        } else {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                    <Typography variant = 'subtitle2' color = 'primary'>Name</Typography>
                    <Typography variant = 'body2'>{this.props.config.name}</Typography>
                </div>
            )
        }
    }

    renderURL = (edit) => {
        if (edit) {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', borderRadius : '5px', padding : '5px'}}>
                    <TextField
                        style = {{width : '100%'}}
                        label = "External URL"
                        value = {this.state.url}
                        onChange = {(event) => {
                            if (event.target.value !== "") {
                                this.updateState('url', event.target.value)
                            } else {
                                this.updateState('url', null)
                            }
                        }}
                        variant = 'filled'
                        size = 'small'
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                https://
                              </InputAdornment>
                            ),
                          }}
                    />
                </div>
            )
        } else {
            return (
                <div style = {{width : '25%', flexGrow: 1, margin : '5px', border : '1px solid rgba(0,0,0,0.12)', borderRadius : '5px', padding : '5px'}}>
                    <Typography variant = 'subtitle2' color = 'primary'>External URL</Typography>
                    <Typography variant = 'body2'>{'https://' + this.props.config.default_params.url}</Typography>
                </div>
            )
        }
    }

    renderUnsafeRouting = (edit) => {
        return (
            <FormControl component="fieldset">
                <FormControlLabel
                    control={<Switch disabled = {this.state.name === null || this.state.url === null} checked={this.state.unsafe_http} onChange={(event) => this.updateState('unsafe_http', event.target.checked)} name="unsafe_http" />}
                    label="Allow Unsafe HTTP rerouting."
                />
                <FormHelperText>This will generate a proxy HTTPS route used to embed, which will inturn re-route to the external URL.</FormHelperText>
            </FormControl>
        )
    }

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, setting_tab_index : newValue})
    }

    renderTabContent = () => {
        switch (this.state.setting_tab_index) {
            case 0 :
              return this.renderQueryParams()
            case 1:
              return this.renderViewConfig()
            default :
              return null
        }
    }

    renderQueryParams = () => {
        return (
            <div style = {{width : '100%', padding : '10px'}}>
                <Typography variant = 'subtitle2' style = {{marginBottom : '5px'}}>Query Parameters</Typography>
                <div style = {{padding : '5px'}}>
                    {this.state.query_params.map(query_param => {
                        return this.renderQueryParam(query_param)
                    })}
                </div>
                <Button
                    style = {{marginTop : '10px'}}
                    variant = 'outlined'
                    size = 'small'
                    color = 'primary'
                    startIcon = {<Add/>}
                    onClick = {this.addQueryParam}
                    disabled = {this.hasUnnamedQueryParams() || (this.props.config.id !== this.props.editing_id)}
                >
                    Add Query Param
                </Button>
            </div>
        )
    }

    hasUnnamedQueryParams = () => {
        let unnamed_params = this.state.query_params.filter(query_param => query_param.name === "")
        if (unnamed_params.length === 0) {
            return false
        } else {
            return true
        }
    }

    addQueryParam = () => {
        let query_param_temp = {
            id : uuidv4(),
            name : "",
            key : "",
            default_value: ""
        }
        let query_params = [...this.state.query_params]
        query_params.push(query_param_temp)
        this.setState({...this.state, query_params : query_params})
    }

    deleteQueryParam = (query_param) => {
        let query_param_index = this.state.query_params.findIndex(qp => qp.id === query_param.id)
        if (query_param_index !== -1) {
            let query_params = [...this.state.query_params]
            query_params.splice(query_param_index, 1)
            this.setState({...this.state, query_params : query_params})
        }
    }

    updateQueryParam = (query_param, update_key, new_value) => {
        let query_param_index = this.state.query_params.findIndex(qp => qp.id === query_param.id)
        if (query_param_index !== -1) {
            let query_params = [...this.state.query_params]
            query_params[query_param_index][update_key] = new_value
            this.setState({...this.state, query_params : query_params})
        }
    }

    renderQueryParam = (query_param) => {
        return (
            <Paper variant = 'outlined' style = {{width : '100%', padding : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center', marginBottom : '10px'}}>
                <TextField
                    style = {{flexGrow: 1, marginRight : '5px'}}
                    disabled = {this.props.config.id !== this.props.editing_id}
                    label = "Name"
                    value = {query_param.name}
                    helperText = "Name of the query Param"
                    onChange = {(event) => {
                        if (event.target.value !== "") {
                            this.updateQueryParam(query_param, 'name',event.target.value)
                        } else {
                            this.updateQueryParam(query_param, 'name', null)
                        }
                    }}
                    variant = 'filled'
                    size = 'small'
                />
                <TextField
                    style = {{flexGrow: 1,marginRight : '5px'}}
                    disabled = {this.props.config.id !== this.props.editing_id}
                    label = "Key"
                    helperText = "Key to be passed as part of the URL"
                    value = {query_param.key}
                    onChange = {(event) => {
                        if (event.target.value !== "") {
                            this.updateQueryParam(query_param, 'key',event.target.value)
                        } else {
                            this.updateQueryParam(query_param, 'key', null)
                        }
                    }}
                    variant = 'filled'
                    size = 'small'
                />
                <TextField
                    style = {{flexGrow: 1, marginRight : '5px'}}
                    disabled = {this.props.config.id !== this.props.editing_id}
                    label = "Default Value"
                    helperText = "Default Value if any"
                    value = {query_param.default_value}
                    onChange = {(event) => {
                        if (event.target.value !== "") {
                            this.updateQueryParam(query_param, 'default_value',event.target.value)
                        } else {
                            this.updateQueryParam(query_param, 'default_value', null)
                        }
                    }}
                    variant = 'filled'
                    size = 'small'
                />
                <IconButton disabled = {this.props.config.id !== this.props.editing_id} style = {{marginLeft : '5px'}} size = 'small' color = 'secondary' onClick = {() => this.deleteQueryParam(query_param)}>
                    <Clear size = 'small'/>
                </IconButton>
            </Paper>
        )
    }

    renderViewConfig = () => {
        return (
            <div style = {{width : '100%', padding : '10px'}}>
                <Typography variant = 'subtitle2' style = {{marginBottom : '5px'}}>View Configurations</Typography>
                <div style = {{padding : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
                    <FormControlLabel
                        disabled = {this.props.config.id !== this.props.editing_id}
                        control={
                            <Checkbox
                                checked={this.state.is_standalone}
                                onChange={(event) => {
                                    if (event.target.checked === false) {
                                        this.setState({...this.state, is_standalone: false, show_in_sidebar : false})
                                    } else {
                                        this.setState({...this.state, is_standalone: true})
                                    }
                                }}
                                name="standalone"
                                color="primary"
                            />
                            }
                        label="Standalone Screen"
                    />
                    {this.state.is_standalone && <FormControlLabel
                        disabled = {this.props.config.id !== this.props.editing_id}
                        control={
                            <Checkbox
                                checked={this.state.show_in_sidebar}
                                onChange={(event) => this.updateState("show_in_sidebar", event.target.checked)}
                                name="show_in_sidebar"
                                color="primary"
                            />
                            }
                        label="Show link in the sidebar menu"
                    />}
                </div>
            </div>
        )
    }

    renderLinkedScreen = (edit) => {
        return (
            <Paper style = {{width : '100%', marginTop : '10px'}}>
                <div style = {{width : '100%', padding: '10px', display : 'flex', flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <div style = {{margin : '5px', display : 'flex', flexDirection : 'row', alignItems : 'center', justifyContent : 'center'}}>
                        <Tooltip title = 'Show Settings' >
                            <IconButton onClick = {() => this.updateState('show_settings', !this.state.show_settings)}>
                                {this.state.show_settings ? <ExpandLess fontSize = 'small'/> : <ExpandMore fontSize = 'small'/>}
                            </IconButton>
                        </Tooltip>
                    </div>
                    {this.renderName(edit)}
                    {this.renderURL(edit)}
                    {this.renderActions(edit)}
                </div>
                <Collapse in = {this.state.show_settings}>
                    <div style = {{width : '100%', padding : '2px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1, marginLeft : '5px'}} variant = 'subtitle2'>Settings & Configuration</Typography>
                    </div>
                    <AntTabs
                        value={this.state.setting_tab_index}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleTabChange}
                        aria-label="Display Config Tabs"
                    >
                        <AntTab label="Query Parameters" />
                        <AntTab label="View Configuration" />
                    </AntTabs>
                    {this.renderTabContent()}
                </Collapse>
                {this.renderSubmit(edit)}
            </Paper>
        )
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                {this.renderLinkedScreen(this.props.editing_id === this.props.config.id ? true : false)}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(Link);